// extracted by mini-css-extract-plugin
export default {"container":"Nochapter_container__sVWA+"};